"use client";

import { HeartCrack, RefreshCwIcon } from "lucide-react";
import type { ReactNode } from "react";

export function ErrorPageContent({
  contactMessage,
}: {
  contactMessage: ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        padding: "24px",
        background: "#F9FAFB",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: "420px",
          width: "100%",
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
          padding: "40px 32px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            margin: "0 auto 20px",
            borderRadius: "50%",
            background: "hsl(198, 69%, 93%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HeartCrack
            size={24}
            color="hsl(198, 69%, 46%)"
            fill="hsl(198, 69%, 85%)"
          />
        </div>

        <h1
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#111827",
            margin: "0 0 8px",
          }}
        >
          Oops, we hit a snag
        </h1>

        <p
          style={{
            fontSize: "14px",
            color: "#6B7280",
            lineHeight: 1.6,
            margin: "0 0 24px",
          }}
        >
          A refresh usually fixes this. If not, {contactMessage}.
        </p>

        <button
          onClick={() => window.location.reload()}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            fontSize: "14px",
            fontWeight: 500,
            color: "#ffffff",
            background: "hsl(198, 69%, 46%)",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          <RefreshCwIcon size={16} />
          Refresh page
        </button>
      </div>
    </div>
  );
}
